import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative flex justify-end" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = ["onClick", "onMouseenter", "onMouseleave", "data-key"]
const _hoisted_5 = { class: "flex flex-row items-center space-x-2 pointer-events-none" }
const _hoisted_6 = {
  key: 0,
  class: "h-3 w-3 text-gray-400 pointer-events-none",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "py-1" }
const _hoisted_10 = ["onClick"]

import { onBeforeMount, onBeforeUnmount, ref, computed, onMounted, watchEffect } from "vue";
	import { Z } from "@/utils/zindex";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'MoreActionsTag',
  props: {
		styleSubMenu: {
			type: String,
			default: "left-[-100px]",
		},
		src: {
			type: String,
			default: "/media/icons/settings-icon.svg",
		},
		data: {
			Type: Object,
			default: {},
		},
		onClick: {
			Type: Function,
			default: (data: any) => {
				//
			},
		},
		onClickSubMEnu: {
			Type: Function,
			default: (data: any) => {
				//
			},
		},
		options: {
			Type: Array,
			default: [
				{
					icon: "/media/icons/edit-dropdown-icon.svg",
					label: "default label",
					name: "defaultNameOption",
					submenu: [],
				},
			],
		},
	},
  setup(__props) {

	const props = __props;

	const subMenu = ref(null);
	const menu = ref(null);
	const showDropDown = ref(false);
	const showSubDropDown: any = ref([]);

	const subMenuWidth = ref(0);

	const closeListerner = (e: any) => {
		if (catchOutsideClick(e, menu))
			window.removeEventListener("click", closeListerner), (showDropDown.value = false);
	};

	const openDropDown = () => {
		window.addEventListener("click", closeListerner, true);
		showDropDown.value = !showDropDown.value;
	};

	const openSubMenu = (event: any, index: number) => {
		//Si des sous menus existent
		if (props.options[index].submenu?.length != 0) {
			// ouverture du sous menu uniquement sur l'element cible
			if (index == event.target.dataset.key)
				showSubDropDown.value[index] = !showSubDropDown.value[index];
			else showSubDropDown.value[index] = !showSubDropDown.value[index];
		}
	};

	const catchOutsideClick = (event: any, dropdown: any) => {
		// When user clicks menu — do nothing
		if (dropdown == event.target) return false;

		// When user clicks outside of the menu — close the menu
		if (showDropDown.value && dropdown != event.target) return true;
	};

	/**
	 * Lifecycle
	 */
	onBeforeMount(async () => {
		props.options.forEach((element, index) => {
			showSubDropDown.value[index] = false;
		});
	});

	onMounted(() => {
		//
	});

	// Audit UX 16 mai 2026 : l'ancien design détachait le listener à la
	// fermeture, mais si le composant est unmount avec le dropdown ouvert
	// (cas v-if/v-for dans une liste qui se rafraîchit), le listener
	// restait attaché à window → fuite mémoire cumulée. Nettoyage garanti.
	onBeforeUnmount(() => {
		window.removeEventListener("click", closeListerner, true);
	});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "p-1.5 rounded-md hover:bg-secondary transition-colors focus:outline-none",
      onClick: _withModifiers(openDropDown, ["stop"]),
      "aria-expanded": showDropDown.value,
      "aria-haspopup": "menu",
      "aria-label": "Plus d'actions",
      title: "Plus d'actions"
    }, [
      _createVNode(_component_Icon, {
        src: "/media/icons/more-actions-icons.svg",
        css: "h-5 w-5 cursor-pointer"
      })
    ], 8, _hoisted_2),
    (showDropDown.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "menu",
          ref: menu,
          class: "absolute flex flex-col h-auto rounded-lg right-5 top-8 bg-[#1f2937] border border-gray-600 shadow-xl z-50 min-w-[180px]"
        }, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                onClick: _withModifiers(() => __props.onClick(__props.data, item.name), ["stop"]),
                onMouseenter: ($event: any) => (showSubDropDown.value[index] = true),
                onMouseleave: ($event: any) => (showSubDropDown.value[index] = false),
                "data-key": index,
                class: "relative flex flex-row items-center justify-between px-3 py-2 cursor-pointer hover:bg-secondary text-sm text-gray-200 transition-colors"
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_Icon, {
                    src: item.icon,
                    css: "h-4 w-4"
                  }, null, 8, ["src"]),
                  _createElementVNode("span", null, _toDisplayString(item.label), 1)
                ]),
                (item.submenu && item.submenu.length)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true),
                (showSubDropDown.value[index] && item.submenu && item.submenu.length != 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      ref_for: true,
                      ref_key: "subMenu",
                      ref: subMenu,
                      class: _normalizeClass([
							__props.styleSubMenu,
							'absolute top-0 flex flex-col bg-[#1f2937] border border-gray-600 rounded-lg shadow-xl min-w-[160px] z-[60]',
						])
                    }, [
                      _createElementVNode("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.submenu, (item2, index2) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index2,
                            onClick: _withModifiers(() => __props.onClick(__props.data, item.name, item2.name), ["stop"]),
                            class: "flex flex-row items-center px-3 py-2 space-x-2 cursor-pointer hover:bg-secondary text-sm text-gray-200 transition-colors"
                          }, [
                            _createVNode(_component_Icon, {
                              src: item2.icon,
                              css: "h-4 w-4"
                            }, null, 8, ["src"]),
                            _createElementVNode("span", null, _toDisplayString(item2.label), 1)
                          ], 8, _hoisted_10))
                        }), 128))
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 40, _hoisted_4))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})